import React, {useCallback, useEffect, useMemo, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Chatbot} from '@robylon/web-react-sdk'
import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'

const RobylonChatbot = ({apiKey}) => {
    const {data: customer} = useCurrentCustomer()
    const {getTokenWhenReady} = useAccessToken()

    const getTokenRef = useRef(getTokenWhenReady)
    getTokenRef.current = getTokenWhenReady

    const customerType = customer?.customerType
    const isRegistered = customerType === 'registered'
    const email = customer?.email

    const [auth, setAuth] = useState({userId: undefined, token: undefined, resolved: false})

    useEffect(() => {
        let isMounted = true
        if (customerType == null) {
            if (isMounted) setAuth({userId: undefined, token: undefined, resolved: false})
            return () => {
                isMounted = false
            }
        }

        const resolveAuth = async () => {
            if (!isRegistered) {
                return {userId: undefined, token: undefined, resolved: true}
            }

            const token = await getTokenRef.current().catch(() => undefined)

            return {userId: email, token, resolved: true}
        }

        resolveAuth().then((next) => {
            if (isMounted) setAuth(next)
        })

        return () => {
            isMounted = false
        }
    }, [customerType, isRegistered, email])

    const handleChatbotEvent = useCallback(() => {}, [])

    const firstName = customer?.firstName
    const lastName = customer?.lastName
    const phoneHome = customer?.phoneHome
    const phoneMobile = customer?.phoneMobile
    const userProfile = useMemo(
        () =>
            isRegistered
                ? {
                      name: [firstName, lastName].filter(Boolean).join(' '),
                      email,
                      mobile: phoneHome || phoneMobile || undefined
                  }
                : undefined,
        [isRegistered, firstName, lastName, email, phoneHome, phoneMobile]
    )

    if (!apiKey || !auth.resolved) return null

    return (
        <Chatbot
            api_key={apiKey}
            user_id={auth.userId}
            user_token={auth.token}
            user_profile={userProfile}
            onEvent={handleChatbotEvent}
        />
    )
}

RobylonChatbot.propTypes = {
    apiKey: PropTypes.string
}

export default RobylonChatbot
